import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/course_history`;

export const ACTION_TYPES = {
  FETCH_COURSEHISTORYHISTORY_LIST: 'coursehistory/FETCH_COURSEHISTORY_LIST',
  FETCH_COURSEHISTORY: 'coursehistory/FETCH_COURSEHISTORY',
  FETCH_COURSEHISTORY_BYCLASS: 'coursehistory/FETCH_COURSEHISTORY_BYCLASS',
  FETCH_COURSEHISTORY_BYCOURSE: 'coursehistory/FETCH_COURSEHISTORY_BYCOURSE',
  FETCH_COURSEHISTORY_BYUSER: 'coursehistory/FETCH_COURSEHISTORY_BYUSER',
  CREATE_COURSEHISTORY: 'coursehistory/CREATE_COURSEHISTORY',
  UPDATE_COURSEHISTORY: 'coursehistory/UPDATE_COURSEHISTORY',
  DELETE_COURSEHISTORY: 'coursehistory/DELETE_COURSEHISTORY',
  DELETE_USERHISTORY: 'coursehistory/DELETE_USERHISTORY',
  RESET: 'coursehistory/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entities2: [],
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  pageable2: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  totalElements2: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const coursehistoryReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_COURSEHISTORY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_COURSEHISTORY_BYCLASS):
    case REQUEST(ACTION_TYPES.FETCH_COURSEHISTORY_BYCOURSE):
    case REQUEST(ACTION_TYPES.FETCH_COURSEHISTORY_BYUSER):
    case REQUEST(ACTION_TYPES.FETCH_COURSEHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_COURSEHISTORY):
    case REQUEST(ACTION_TYPES.UPDATE_COURSEHISTORY):
    case REQUEST(ACTION_TYPES.DELETE_COURSEHISTORY):
    case REQUEST(ACTION_TYPES.DELETE_USERHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_COURSEHISTORY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_COURSEHISTORY):
    case FAILURE(ACTION_TYPES.FETCH_COURSEHISTORY_BYCLASS):
    case FAILURE(ACTION_TYPES.FETCH_COURSEHISTORY_BYCOURSE):
    case FAILURE(ACTION_TYPES.FETCH_COURSEHISTORY_BYUSER):
    case FAILURE(ACTION_TYPES.CREATE_COURSEHISTORY):
    case FAILURE(ACTION_TYPES.UPDATE_COURSEHISTORY):
    case FAILURE(ACTION_TYPES.DELETE_COURSEHISTORY):
    case FAILURE(ACTION_TYPES.DELETE_USERHISTORY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_COURSEHISTORY_LIST):
    case SUCCESS(ACTION_TYPES.FETCH_COURSEHISTORY_BYCLASS):
    case SUCCESS(ACTION_TYPES.FETCH_COURSEHISTORY_BYCOURSE):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_COURSEHISTORY_BYUSER):
        let res2 = action.payload.data;
        return {
          ...state,
          loading: false,
          entities2: res2.content,
          pageable2: {
            sort: {
              sorted: res2.pageable.sort.sorted,
              unsorted: res2.pageable.sort.unsorted,
              empty: res2.pageable.sort.empty,
            },
            pageSize: res2.pageable.page_size,
            pageNumber: res2.pageable.page_number,
            offset: res2.pageable.offset,
            paged: res2.pageable.paged,
            unpaged: res2.pageable.unpaged,
          },
          totalElements2: res2.total_elements,
        };
    case SUCCESS(ACTION_TYPES.FETCH_COURSEHISTORY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_COURSEHISTORY):
    case SUCCESS(ACTION_TYPES.UPDATE_COURSEHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
        successMessage: action.payload.meta,
      };
    case SUCCESS(ACTION_TYPES.DELETE_COURSEHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case SUCCESS(ACTION_TYPES.DELETE_USERHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default coursehistoryReducer;

// ACTIONS
export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_COURSEHISTORY_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntitiesByClass = (id, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_COURSEHISTORY_BYCLASS,
  payload: axios.get(`${apiUrl}/classroom/${id}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const SearchUserByName = (condition, idclass, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_COURSEHISTORY_BYCLASS,
  payload: axios.get(`${apiUrl}/search?q=${condition},classroom.id:${idclass}`, {
    params: {
      page: undefined || page,
      sort: undefined || sort,
      size: undefined || size,
    },
  })
});

export const getEntitiesJoinRequest = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_COURSEHISTORY_BYCLASS,
  payload: axios.get(`${apiUrl}/join_request`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntitiesByCourse = (id, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_COURSEHISTORY_BYCOURSE,
  payload: axios.get(`${apiUrl}/course/${id}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_COURSEHISTORY,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_COURSEHISTORY,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil Input!` },
  });
  return result;
};

export const updateUserCourseStatus = (id, userid, idclass, pagination, size, sortTable, keystatus, condition) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_USERHISTORY,
    payload: axios.post(`${apiUrl}/course/${id}/user/${userid}/override_finish`),
    meta: { successMessage: `Berhasil update!` },
  });
  if(keystatus===true){
    dispatch(SearchUserByName(condition, idclass, pagination-1, size, sortTable));
  }else{
    dispatch(getEntitiesByClass(idclass, pagination-1, size, sortTable));
  }
  
  return result;
};

export const updateEntity = (entity, id, idcourse) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_COURSEHISTORY,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  dispatch(getEntitiesByCourse(idcourse, null, 10));
  return result;
};

export const deleteUserHistory = (courseid, userid, idclass, pagination, sort, keystatus, condition) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_USERHISTORY,
    payload: axios.delete(`${apiUrl}/course/${courseid}/user/${userid}`),
    meta: { successMessage: `Berhasil Hapus!` },
  });
  if(keystatus===true){
    dispatch(SearchUserByName(condition, idclass, pagination-1, sort));
  }else{
    dispatch(getEntitiesByClass(idclass, pagination-1, 10, sort));
  }
  
  return result;
};

export const deleteListUserHistory = (courseid, payload, idclass, pagination, size, sort, keystatus, condition) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_USERHISTORY,
    payload: axios.post(`${apiUrl}/course/${courseid}/bulk-kick-user`, payload),
    meta: { successMessage: `Berhasil Hapus!` },
  });
  if(keystatus===true){
    dispatch(SearchUserByName(condition, idclass, pagination-1, size, sort));
  }else{
    dispatch(getEntitiesByClass(idclass, pagination-1, size, sort));
  }
  
  return result;
};

export const deleteEntity = (id, idclass, status) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_COURSEHISTORY,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { successMessage: `Berhasil Hapus!` },
  });
  if (status === 'kelas') {
    dispatch(getEntitiesByClass(idclass, null, 10));
  } else {
    dispatch(getEntitiesByCourse(idclass, null, 10));
  }
  return result;
};

export const getEntitiesByUserId = (id, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_COURSEHISTORY_BYUSER,
  payload: axios.get(`${apiUrl}/user/${id}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
